var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-12"},[_c('iframe',{attrs:{"src":_vm.field.properties.basic.url,"frameBorder":"0","scrolling":"auto","height":"800px","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }